import type { IconProps } from '../create-icon'

export function LoLTop({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill={color}
      fillRule="evenodd"
      className={className}
      style={style}
      {...rest}
    >
      <path opacity="0.5" d="M21,14H14v7h7V14Zm5-3V26L11.014,26l-4,4H30V7.016Z" />
      <polygon points="4 4 4.003 28.045 9 23 9 9 23 9 28.045 4.003 4 4" />
    </svg>
  )
}
